<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="home-1">
      <div class="title">Tìm khoản vay dễ dàng</div>
      <div class="sbtitle">Thông qua Vay Thông Minh, chúng tôi tư vấn thông minh các sản phẩm vay phù hợp với bạn, nhanh
        chóng, tiện lợi và minh bạch, giúp bạn dễ dàng giải quyết các nhu cầu tài chính một cách an toàn và đáng tin
        cậy.</div>
    </div>

    <div class="partner">
      <div class="title">Ưu điểm của ứng dụng
      </div>
      <div class="partner-box">
        <div class="item">
          <img src="../assets/home-2.png?v2" alt="">
          <div>Khuyến nghị thông minh</div>
          <p>Kết hợp chính xác các sản phẩm tài chính phù hợp theo nhu cầu của bạn.</p>
        </div>
        <div class="item">
          <img src="../assets/home-3.png?v3" alt="">
          <div>Bảo mật dữ liệu</div>
          <p>Sử dụng công nghệ mã hóa để đảm bảo thông tin cá nhân và an ninh tài chính.</p>
        </div>
        <div class="item">
          <img src="../assets/home-4.png?v3" alt="">
          <div>Nhanh chóng và dễ dàng</div>
          <p>Đơn giản hóa quy trình đăng ký và tiền sẽ đến tài khoản của bạn một cách nhanh chóng.</p>
        </div>
      </div>
    </div>

    <div class="img-text-box">
      <img src="../assets/home-5.png?v1" alt="">
      <div class="text-box">
        <div>Tại sao thúc đẩy tài chính trực tuyến</div>
        <p>Thúc đẩy tài chính trực tuyến có thể cung cấp các dịch vụ thuận tiện hơn và nhanh hơn, cho phép người dùng
          nhận được các sản phẩm tài chính mọi lúc, mọi nơi. Nó hạ thấp ngưỡng đối với các ngân hàng truyền thống, cải
          thiện khả năng tiếp cận và hiệu quả của các dịch vụ tài chính, đồng thời đáp ứng nhu cầu tài chính nhanh chóng
          và an toàn của người dân hiện đại.</p>
      </div>
    </div>
    <div class="img-text-box">
      <div class="text-box">
        <div>Tại sao chọn Vay Thông Minh?</div>
        <p>Khi chọn Vay Thông Minh, bạn có thể dễ dàng tìm thấy các sản phẩm tài chính đáp ứng nhu cầu của mình và nền
          tảng sẽ đề xuất giải pháp cho vay tốt nhất một cách thông minh dựa trên thông tin cá nhân của bạn. Chúng tôi
          tập trung vào bảo mật dữ liệu, sử dụng công nghệ mã hóa tiên tiến để bảo vệ quyền riêng tư của bạn, cung cấp
          quy trình cho vay thuận tiện và minh bạch, đồng thời đảm bảo rằng bạn nhận được các dịch vụ tài chính hiệu quả
          và an toàn.
        </p>
      </div>
      <img src="../assets/home-6.png?v1" alt="">
    </div>
    <img src="../assets/home-7.png" class="home-7">

    <div class="rank-box">
      <div class="title">Phân loại doanh nghiệp của Vay Thông Minh</div>
      <div class="sbtitle">Vay Thông Minh sẽ tiếp tục tối ưu hóa các thuật toán đề xuất thông minh, mở rộng hợp tác sản
        phẩm tài chính hơn nữa, cải thiện trải nghiệm người dùng và phấn đấu trở thành nền tảng dịch vụ tài chính hàng
        đầu.</div>
      <div class="item-box">
        <div class="item">
          <img src="../assets/home-8.png" alt="">
          <div>Khuyến nghị cho vay</div>
          <p>Dựa trên nhu cầu của người dùng, nó sẽ đề xuất một cách thông minh các sản phẩm cho vay phù hợp, bao gồm
            các khoản vay nhỏ, vay tín dụng, v.v., để giúp người dùng giải quyết nhanh chóng nhu cầu vốn của mình.</p>
        </div>
        <div class="item">
          <img src="../assets/home-9.png" alt="">
          <div>đánh giá tín dụng</div>
          <p>Cung cấp dịch vụ đánh giá tín dụng cá nhân để giúp người dùng hiểu được trạng thái tín dụng của họ và nhận
            được các đề xuất khoản vay được cá nhân hóa để cải thiện tỷ lệ phê duyệt khoản vay.</p>
        </div>
        <div class="item">
          <img src="../assets/home-10.png" alt="">
          <div>tư vấn tài chính</div>
          <p>Cung cấp cho người dùng dịch vụ tư vấn tài chính chuyên nghiệp giúp họ hiểu rõ hơn về sản phẩm tài chính,
            quản lý tài chính tối ưu và đưa ra những quyết định sáng suốt.
          </p>
        </div>
      </div>
    </div>

    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'

export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
    Swiper,
    SwiperSlide,
    directive
  },
  data() {
    return {
      name: '',
      address: '',
      pagination: {
        autoplay: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
      }
    }
  },
  mounted() {

  },
  methods: {
    SubmitOk() {
      if (!this.name) {
        return alert('please enter your name')
      } else if (!this.address) {
        return alert('please enter your email address')
      }
      alert('Submitted successfully')
    }
  }
}
</script>
<style lang="less" scoped>
.title {
  font-weight: 600;
  font-size: 48px;
  color: #0E235F;
  text-align: center;
}

.sbtitle {
  font-size: 18px;
  color: #0E235F;
  margin-top: 17px;
  text-align: center;
}

.home-1 {
  height: 800px;
  background: url(../assets/home-1.png?v1);
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 360px;
}

.partner {
  padding: 100px 360px;

  .partner-box {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 65px;

    .item {
      width: 280px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        width: 44px;
      }

      div {
        font-weight: 900;
        font-size: 18px;
        color: #0E235F;
        margin-top: 31px;
      }

      p {
        font-size: 18px;
        color: #999999;
        margin-top: 18px;
      }
    }
  }
}

.img-text-box {
  padding: 0px 360px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    width: 585px;
  }

  .text-box {
    width: 550px;

    div {
      font-weight: 600;
      font-size: 50px;
      color: #0E235F;
    }

    p {
      font-size: 18px;
      color: #999999;
      margin-top: 46px;
    }
  }
}

.home-7 {
  width: 100%;
  margin-top: 100px;
}

.rank-box {
  padding: 100px 360px;

  .item-box {
    margin-top: 64px;
    display: flex;
    align-items: self-start;
    justify-content: space-between;

    .item {
      width: 380px;

      img {
        width: 380px;
      }

      div {
        font-weight: 900;
        font-size: 20px;
        color: #0E235F;
        margin-top: 24px;
      }

      p {
        font-weight: 600;
        font-size: 16px;
        color: #999999;
        margin-top: 16px;
      }
    }
  }
}
</style>
